/*
 * AddStudent Messages
 *
 * This contains all the text for the AddStudent component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    assignClass: {
        id: 'app.components.assignedClassesGroups.assignClass',
        defaultMessage: 'Assign Class'
    }
});



// WEBPACK FOOTER //
// ./app/components/assigned-classes-groups/messages.js